/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import MDButton from "components/MDButton";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import ControlledSelect from "components/FormInputs/ControlledSelect";
import ControlledAutoComplete from "components/FormInputs/ControlledAutoComplete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import "react-csv-importer/dist/index.css";

function ProductNode({
  productsList,
  control,
  removeProductNode,
  watch,
  setValue,
  resetField,
  index,
  state,
  setQuotationStatus,
}) {
  const [filterProducts, setFilterProducts] = useState([]);
  const [productVariations, setProductVariations] = useState([]);
  const [, setSelectedAttributes] = useState([]);

  const productInput = watch(`products.${index}.product`);
  const variationInput = watch(`products.${index}.variation`);
  const qtyInput = watch(`products.${index}.qty`);
  const typeInput = watch(`products.${index}.type`);

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      createProductVariations(productsList);
    } else {
      setFilterProducts([]);
    }
  }, [productsList]);

  useEffect(() => {
    if (productInput) {
      let filterProduct = filterProducts.filter((item) => item.id == productInput);
      if (filterProduct) {
        if (filterProduct.length > 0) {
          setValue(`products.${index}.type`, filterProduct[0].type);
          if (filterProduct[0].type == "variable") {
            if (
              filterProduct[0].productVariations &&
              filterProduct[0].productVariations.length > 0
            ) {
              setProductVariations(filterProduct[0].productVariations);
            }
          } else {
            setProductVariations([]);
          }
        } else {
          let parentProduct = filterProducts.find((p) =>
            p.productVariations?.some((v) => v.id == productInput)
          );
          if (parentProduct) setValue(`products.${index}.product`, parentProduct.id);
        }
      }
    } else {
      resetField(`products.${index}.variation`);
      setProductVariations([]);
    }
  }, [productInput, filterProducts]);

  useEffect(() => {
    console.log(variationInput);
    if (variationInput) {
      let filteredProduct = productsList.filter((item) => item.id == variationInput);
      if (filteredProduct && filteredProduct.length > 0) {
        if (
          filteredProduct[0].variation_atribute_option &&
          filteredProduct[0].variation_atribute_option.length > 0
        ) {
          let attributes = [];
          for (let attribute of filteredProduct[0].variation_atribute_option) {
            if (attribute.products_attribute_options) {
              attributes.push(attribute.products_attribute_options.option);
            }
          }
          setSelectedAttributes(attributes);
          setValue(`products.${index}.attributes`, attributes);
        }
      }
    }
  }, [variationInput, filterProducts]);

  const createProductVariations = (products) => {
    const productMap = {};

    // Iterate through the response and create a mapping of parent IDs to products
    products.forEach((product) => {
      const productId = product.id;
      const parentId = product.parent_id;

      // Create 'productVariations' property for each product
      const productWithVariations = Object.assign({}, product, { productVariations: [] });

      if (parentId === 0) {
        // If the product has no parent, add it to the main products array
        productMap[productId] = productWithVariations;
      } else {
        // If the product has a parent, add it as a variation to the parent
        if (!productMap[parentId].productVariations) {
          productMap[parentId].productVariations = [];
        }
        productMap[parentId].productVariations.push(product);
      }
    });

    Object.values(productMap).forEach((product) => {
      if (product.productVariations.length > 0) {
        const prices = product.productVariations.map((variation) => variation.price);
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        product.priceRange =
          minPrice == maxPrice ? `${product.price}` : `${minPrice} - ${maxPrice}`;
        product.minPrice = minPrice;
      } else {
        product.priceRange = `${product.price}`;
      }
    });

    let filterMappedProdcuts = Object.values(productMap)
      .filter((product) => !(product.type == "variable" && product.productVariations.length == 0))
      .sort((a, b) => b.priority - a.priority);

    // Set the products state with the main products array
    setFilterProducts(filterMappedProdcuts);
  };

  useEffect(() => {
    if (state) {
      if (productInput && qtyInput) {
        if (typeInput == "variable") {
          if (variationInput) {
            setQuotationStatus(true);
          }
        } else {
          setQuotationStatus(true);
        }
      }
    }
  }, [productInput, variationInput, qtyInput]);

  return (
    <MDBox
      sx={{
        border: "1px solid #d2d6da",
        borderRadius: "0.375rem",
        mb: 3,
        pt: 2,
        pl: 1,
        position: "relative",
        "& .tox-tinymce": { border: "none", position: "relative" },
      }}
      key={index}
    >
      <MDTypography
        component="p"
        color="info"
        sx={{
          lineHeight: "1.5",
          fontSize: "0.8rem",
          fontWeight: 500,
          transform: "translate(7px, -50%)",
          backgroundColor: "#fff",
          color: "#7b809a",
          padding: "0 5px",
          position: "absolute",
          left: 0,
          top: 0,
          zIndex: 1,
        }}
      >
        Item {index + 1}
      </MDTypography>
      <GridContainer sx={{ mt: 0.5 }}>
        <GridItem xs={12} sm={12} md={11} lg={11} xl={11}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
              <ControlledAutoComplete
                id={`parentProduct${index}`}
                name={`products.${index}.product`}
                control={control}
                options={filterProducts}
                optionLabelProperty="name"
                label="Product"
              />
            </GridItem>

            {productVariations && productVariations.length > 0 && (
              <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
                <ControlledSelect
                  name={`products.${index}.variation`}
                  control={control}
                  label="Select variation *"
                  menu={{
                    id: "id",
                    value: "name",
                    title: "Products",
                    list: productVariations,
                  }}
                  sx={{
                    "& .MuiFormLabel-root": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiInputBase-root": {
                      height: "44px",
                    },
                  }}
                />
              </GridItem>
            )}

            <GridItem xs={12} sm={12} md={4} lg={4} xl={4}>
              <ControlledTextInput
                name={`products.${index}.qty`}
                control={control}
                labelText="QTY *"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "number",
                }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={12} md={1} lg={1} xl={1}>
          <MDButton
            color="warning"
            variant="gradient"
            iconOnly
            onClick={() => removeProductNode(index)}
          >
            <IndeterminateCheckBoxIcon />
          </MDButton>
        </GridItem>
      </GridContainer>
    </MDBox>
  );
}

export default ProductNode;
